export default __webpack_public_path__ + "static/media/ads.e684d78b.txt";